import React from 'react';
import { string, element } from 'prop-types';
import cn from 'classnames';
import { Status } from '@fiverr-private/fit';
import classes from './index.module.scss';

const TOAST_TYPES = {
    ERROR: 'error',
    SUCCESS: 'success',
};

const TYPE_COLOR_MAP = {
    [TOAST_TYPES.ERROR]: Status.COLORS.RED,
    [TOAST_TYPES.SUCCESS]: Status.COLORS.GREEN,
};

const Toast = ({ className, children, type = TOAST_TYPES.SUCCESS }) => (
    <Status className={cn(className, classes.toast)} color={TYPE_COLOR_MAP[type]} theme={Status.THEMES.COLORFUL}>
        {children}
    </Status>
);

Toast.TYPES = TOAST_TYPES;

Toast.propTypes = {
    className: string,
    children: element,
    type: string,
};

export default Toast;
